import { Directive, Input, numberAttribute } from '@angular/core';

/** Shared keyboard focus ring — see `.focus-outline` in `src/scss/core/utilities.scss`. */
@Directive({
  selector: '[focus-outline]',
  standalone: true,
  host: {
    class: 'focus-outline',
    '[style.--focus-outline-offset.px]': 'focusOutline',
  },
})
export class FocusOutlineDirective {
  /**
   * Outline offset in pixels (same meaning as `focus-outline($offset)` in mixins).
   * Default 2, so the ring is drawn outside the control. Example:
   * `[focus-outline]="-2"` for tighter icon-button rings.
   */
  @Input({
    alias: 'focus-outline',
    transform: (value: unknown) => numberAttribute(value, 2),
  })
  focusOutline = 2;
}
